module.exports = __webpack_public_path__ + "img/date_right.5a1bdfb3.png";